export default __webpack_public_path__ + "static/media/down-chevron.be614538.svg";